'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiBatteryFull = function TiBatteryFull(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 26.7c-0.9 0-1.7-0.8-1.7-1.7v-6.7c0-0.9 0.8-1.6 1.7-1.6s1.7 0.7 1.7 1.6v6.7c0 0.9-0.8 1.7-1.7 1.7z m-5 0c-0.9 0-1.7-0.8-1.7-1.7v-6.7c0-0.9 0.8-1.6 1.7-1.6s1.7 0.7 1.7 1.6v6.7c0 0.9-0.8 1.7-1.7 1.7z m15 0c-0.9 0-1.7-0.8-1.7-1.7v-6.7c0-0.9 0.8-1.6 1.7-1.6s1.7 0.7 1.7 1.6v6.7c0 0.9-0.8 1.7-1.7 1.7z m-5 0c-0.9 0-1.7-0.8-1.7-1.7v-6.7c0-0.9 0.8-1.6 1.7-1.6s1.7 0.7 1.7 1.6v6.7c0 0.9-0.8 1.7-1.7 1.7z m11.7-10c0-2.8-2.3-5-5-5h-18.4c-2.7 0-5 2.2-5 5v10c0 2.7 2.3 5 5 5h18.4c2.7 0 5-2.3 5-5 1.8 0 3.3-1.5 3.3-3.4v-3.3c0-1.8-1.5-3.3-3.3-3.3z m-3.4 10c0 0.9-0.7 1.6-1.6 1.6h-18.4c-0.9 0-1.6-0.7-1.6-1.6v-10c0-1 0.7-1.7 1.6-1.7h18.4c0.9 0 1.6 0.7 1.6 1.7v10z' })
        )
    );
};

exports.default = TiBatteryFull;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/battery-full.js
// module id = 1982
// module chunks = 0